import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateDirective } from '../shared/translate.directive';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../shared/services/loader.service';
import { DashboardService } from '../shared/services/dashboard.service';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import localeMk from '@angular/common/locales/mk';
import { getMacedonianPaginatorIntl } from '../custom-paginator-intl';
import { MatDatepickerLocComponent } from '../mat-datepicker-loc/mat-datepicker-loc.component';
import { MatIconModule } from '@angular/material/icon';
import { LanguageProvider } from '../shared/language-provider';
registerLocaleData(localeMk);


@Component({
  selector: 'app-payments',
  standalone: true,
  imports: [TranslateDirective, CommonModule, MatPaginatorModule, FormsModule, MatDatepickerModule, MatInputModule, MatFormFieldModule, MatDatepickerLocComponent, MatIconModule],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'mk-MK' },
    provideNativeDateAdapter(),
    {
      provide: MatPaginatorIntl,
      useFactory: (provider: LanguageProvider) => getMacedonianPaginatorIntl(provider),
      deps: [LanguageProvider]
    }
  ], templateUrl: './payments.component.html',
  styleUrl: './payments.component.less'
})


export class PaymentsComponent {

  constructor(private router: Router, public myLoaderService: LoaderService, private service: DashboardService) { }

  payments: any;
  data: any;
  totalPayments: any;
  InvalidDateFrom: boolean = false
  InvalidDateTo: boolean = false
  selectedDateFrom: Date | null = null;
  selectedDateTo: Date | null = null;
  searchModel: any = {
    PaymentStatus: null,
    DateFrom: null,
    DateTo: null,
    Page: 1,
    Size: 5
  }
  @ViewChild('datepickerFrom') datepickerFrom: MatDatepickerLocComponent | undefined;
  @ViewChild('datepickerTo') datepickerTo: MatDatepickerLocComponent | undefined;
  ngOnInit() {
    this.getAllPayments();
  }


  onDateSelectedFrom(date: Date) {
    this.selectedDateFrom = date;
    this.selectedDateFrom.setDate(this.selectedDateFrom.getDate());
  }

  onDateSelectedTo(date: Date) {
    this.selectedDateTo = date;
    this.selectedDateTo.setDate(this.selectedDateTo.getDate());
  }

  getAllPayments() {
    this.InvalidDateFrom = false;
    this.InvalidDateTo = false;
    const minDate = new Date(1753, 0, 1);

    if ((this.selectedDateFrom != null && this.selectedDateFrom < minDate)) {
      this.InvalidDateFrom = true;
    }
    if ((this.selectedDateTo != null && this.selectedDateTo < minDate)) {
      this.InvalidDateTo = true;
    }

    if (this.selectedDateFrom != null && this.selectedDateTo != null && this.selectedDateFrom > this.selectedDateTo) {
      this.InvalidDateTo = true;
    }

    if (this.InvalidDateFrom || this.InvalidDateTo) {
      return
    }

    this.searchModel.DateFrom = this.selectedDateFrom;
    this.searchModel.DateTo = this.selectedDateTo;
    this.service.getAllPayments(this.searchModel).subscribe(res => {
      this.data = res;
      this.payments = this.data.PaymentGridRecordsModel;
      this.totalPayments = this.data.TotalRecords;

    })
  }

  pageEvent(event: any) {
    this.searchModel.Size = event.pageSize;
    this.searchModel.Page = event.pageIndex + 1;
    this.getAllPayments();
  }

  clearFilter() {
    this.searchModel.Page = 1;
    this.searchModel.PaymentStatus = null;
    this.searchModel.DateTo = null;
    this.searchModel.DateFrom = null;
    this.datepickerFrom?.clearDate();
    this.datepickerTo?.clearDate()
    this.getAllPayments()
  }
}
